import React, { Component, Fragment } from 'react';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { DatePicker, DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ComboBoxAnnee } from '../ComboBox/ComboBoxAnnee';
import { ComboBoxMois } from '../ComboBox/ComboBoxMois';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import '../../css/immocom.css';
import '../List/DetailsListCG.css';
import { DataIndicateur } from '../../data/DataIndicateur';
import PerimetreContext from '../../contexts/PerimetreContext';

var objetState = {
    items: [],
    selectedOperation: {},
    indicateur: {},
    labelPeriode: 'Période non ouverte',
    dateDebutPeriodeOuverte: null,

    enCoursDeTraitement: false,
    messageEnCoursDeTraitement: '',

    onAffichePanelFiltre: false,
    onAffichePanelEdition: false,

    peutAccederSuiviBudgetaire: false,
    peutModifier: false,

    filtreMois: 0,
    filtreAnnee: 0,

    pageIndex: 1,
    facteurNbreEnregistrement: 100,
    tri: "",

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: ''
};

export class DetailsListCGPrevision extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListCGPrevisionWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListCGPrevisionWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        const { items } = this.state;

        return (!this.state.peutAccederSuiviBudgetaire ? null :
            <DetailsList
                setKey="items"
                items={items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={SelectionMode.none}
                columns={this.columns}
                onColumnHeaderClick={this._onColumnHeaderClick}
            />
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'nomOperation',
            name: 'Opération',
            ariaLabel: 'Opération',
            fieldName: 'nomOperation',
            minWidth: 200,
            maxWidth: 600,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.nomOperation}>{item.nomOperation}</span>;
            }
        });
        columnsTemp.push({
            key: 'stock',
            name: 'Nb lgts en stock à fin de période',
            ariaLabel: 'Nb lgts en stock à fin de période',
            fieldName: 'stock',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.stock}>{item.stock}</span>;
            }
        });
        columnsTemp.push({
            key: 'previsionN',
            name: 'Reste à faire sur l\'exercice en nb de lgts',
            ariaLabel: 'Reste à faire sur l\'exercice en nb de lgts',
            fieldName: 'previsionN',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.previsionN}>{item.previsionN}</span>;
            }
        });
        columnsTemp.push({
            key: 'previsionN1',
            name: 'Prévision N+1 en nb de lgts',
            ariaLabel: 'Prévision N+1 en nb de lgts',
            fieldName: 'previsionN1',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.previsionN1}>{item.previsionN1}</span>;
            }
        });
        columnsTemp.push({
            key: 'previsionN2',
            name: 'Prévision N+2 en nb de lgts',
            ariaLabel: 'Prévision N+2 en nb de lgts',
            fieldName: 'previsionN2',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.previsionN2}>{item.previsionN2}</span>;
            }
        });
        columnsTemp.push({
            key: 'previsionN3',
            name: 'Prévision N+3 en nb de lgts',
            ariaLabel: 'Prévision N+3 en nb de lgts',
            fieldName: 'previsionN3',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span title={item.previsionN3}>{item.previsionN3}</span>;
            }
        });
        columnsTemp.push({
            key: 'previsionNAuDela',
            name: 'Prévision au-delà en nb de lgts',
            ariaLabel: 'Prévision au-delà en nb de lgts',
            fieldName: 'previsionNAuDela',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span title={item.previsionNAuDela} className={item.previsionNAuDela < 0 ? 'previsionNegative' : ''}>{item.previsionNAuDela}</span>;
            }
        });
        columnsTemp.push({
            key: 'rythmeExercice',
            name: 'Rythme de commercialisation sur l\'exercice',
            ariaLabel: 'Rythme de commercialisation sur l\'exercice',
            fieldName: 'rythmeExercice',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let rythmeExercice = (item.rythmeExercice !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.rythmeExercice).toFixed(3), true, 3) : null);
                return <span title={rythmeExercice}>{rythmeExercice}</span>;
            }
        });
        columnsTemp.push({
            key: 'rythme',
            name: 'Rythme de commercialisation depuis le lancement de l\'opération',
            ariaLabel: 'Rythme de commercialisation depuis le lancement de l\'opération',
            fieldName: 'rythme',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let rythme = (item.rythme !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.rythme).toFixed(3), true, 3) : null);
                return <span title={rythme}>{rythme}</span>;
            }
        });
        columnsTemp.push({
            key: 'detailIndicateur',
            name: '',
            ariaLabel: 'Editer',
            fieldName: 'detailIndicateur',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (this._onBloqueEdition(item.dateValeur, item.dateClotureCG, item.dateClotureNationaleCG) ? null : <IconButton
                    iconProps={{ iconName: 'Edit' }}
                    title="Editer"
                    ariaLabel="Editer"
                    onClick={() => this._onAffichePanelEdition(item)}
                />);
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des indicateurs en cours'
        });

        let _chargementListeDesINDICATEURSPrevision = DataIndicateur._chargementListeDesINDICATEURSPrevision(this.state.tri, this.state.filtreMois, this.state.filtreAnnee, this.state.facteurNbreEnregistrement, this.state.pageIndex);

        _chargementListeDesINDICATEURSPrevision
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let new_Items = [];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (objetData[0] !== null ? objetData[0] : []);
                    let periodeOuverture = objetData[2];

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items;
                        new_Items = new_Items.concat(listeItem);
                    }

                    this.setState({
                        items: new_Items,
                        labelPeriode: (periodeOuverture.mois !== null && periodeOuverture.annee !== null ? 'Période en cours : ' + periodeOuverture.mois + ' ' + periodeOuverture.annee : 'Période non ouverte'),
                        dateDebutPeriodeOuverte: periodeOuverture.dateDebut,

                        peutAccederSuiviBudgetaire: objetData[1],
                        peutModifier: objetData[3],

                        filtreMois: (this.state.filtreMois === 0 ? (periodeOuverture.dateDebut !== null ? parseInt(Scriba.date().stringDateFormat(periodeOuverture.dateDebut, 'M')) : 0) : this.state.filtreMois),
                        filtreAnnee: (this.state.filtreAnnee === 0 ? (periodeOuverture.annee !== null ? periodeOuverture.annee : 0) : this.state.filtreAnnee),

                        enCoursDeTraitement: false,
                        messageEnCoursDeTraitement: '',

                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutAccederSuiviBudgetaire = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _chargementIndicateur(operation) {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de l\'indicateur en cours'
        });

        let chargementIndicateur = DataIndicateur._chargementIndicateur(operation.compteur);

        chargementIndicateur
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    this.setState({
                        onAffichePanelEdition: true,
                        selectedOperation: operation,
                        indicateur: objetData,

                        enCoursDeTraitement: false,
                        messageEnCoursDeTraitement: '',

                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.indicateur = {};

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'indicateur en cours'
        });

        let _onEnregistrementIndicateur = DataIndicateur._onEnregistrementIndicateur(this.state.indicateur, "prevision");

        _onEnregistrementIndicateur
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onCachePanelEdition();
                    this._chargementDonnees();
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutAccederSuiviBudgetaire = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            estValide = estValide && Scriba.nombre().nombreEstValide(item.previsionN, false, true, 0);
            estValide = estValide && Scriba.nombre().nombreEstValide(item.previsionN1, false, true, 0);
            estValide = estValide && Scriba.nombre().nombreEstValide(item.previsionN2, false, true, 0);
            estValide = estValide && Scriba.nombre().nombreEstValide(item.previsionN3, false, true, 0);
        }
        else {
            estValide = false;
        }

        return estValide;
    }

    _onBloqueEdition = (dateValeur, dateClotureCG, dateClotureNationaleCG) => {
        let onBloque = false;
        let dateClotureCGRenseignee = Scriba.formulaire().nEstPasVide(dateClotureCG);
        let dateClotureNationaleCGRenseignee = Scriba.formulaire().nEstPasVide(dateClotureNationaleCG);

        if (!this.state.peutModifier) {
            onBloque = true
        }
        else {
            if (this.state.dateDebutPeriodeOuverte !== null) {
                if (Scriba.date().getDateFromChaineISO(dateValeur) >= Scriba.date().getDateFromChaineISO(this.state.dateDebutPeriodeOuverte)) {
                    // Clôturée au niveau régional ou national => Pas de modification possible
                    if (dateClotureCGRenseignee || dateClotureNationaleCGRenseignee) {
                        onBloque = true;
                    }
                }
            }
            else {
                onBloque = true;
            }
        }

        return onBloque;
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    }

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    }

    _onAffichePanelEdition = (operation) => {
        this._chargementIndicateur(operation);
    }

    _onCachePanelEdition = () => {
        if (this.state.onAffichePanelEdition) {
            this.setState({ onAffichePanelEdition: false });
        }
    }

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreMois: 0,
            filtreAnnee: 0
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    }

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    }

    _onRenderFooterEditionContent = () => {
        let boutonActif = this._validationFormulaire(this.state.indicateur);

        return (
            <div>
                <PrimaryButton onClick={this._onEnregistrement} className="marginRight8px" disabled={!boutonActif}>Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelEdition}>Fermer</DefaultButton>
            </div>
        );
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {
        const content = this._creationContent();

        return <Fragment>
            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.filtreMois !== 0 || this.state.filtreAnnee !== 0 ? `Réservations / Désistements sur : ${Immocom.conversion().getMoisAPartirNumero(this.state.filtreMois)} ${this.state.filtreAnnee}` : ""}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        <Sticky stickyPosition={StickyPositionType.Header}>
                            <div className="labelPeriodeEnCours">{this.state.labelPeriode}</div>
                        </Sticky>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div>Réservations / Désistements sur</div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <ComboBoxMois
                                onChange={(event, option, index, value, item) => this.setState({ filtreMois: option.key })}
                                selectedKey={this.state.filtreMois}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <ComboBoxAnnee
                                onChange={(event, option, index, value, item) => this.setState({ filtreAnnee: option.key })}
                                selectedKey={this.state.filtreAnnee}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <Panel
                isOpen={this.state.onAffichePanelEdition}
                type={PanelType.medium}
                onDismiss={this._onCachePanelEdition}
                headerText={`Prévisions pour l'opération ${this.state.selectedOperation.nomOperation}`}
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterEditionContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxRegion
                                disabled
                                selectedKey={this.state.indicateur.idRegion}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxAgence
                                disabled
                                idRegion={this.state.indicateur.idRegion}
                                selectedKey={this.state.indicateur.idAgence}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxOperation
                                disabled
                                idAgence={this.state.indicateur.idAgence}
                                idRegion={this.state.indicateur.idRegion}
                                perimetre="eiffage"
                                selectedKey={this.state.indicateur.idOperation}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prévision N"
                                value={this.state.indicateur.reservationPrevisionNbResteAEffectuerAnneeN}
                                onBlur={e => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbResteAEffectuerAnneeN", e.target.value)}
                                onChanged={value => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbResteAEffectuerAnneeN", value)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prévision N+1"
                                value={this.state.indicateur.reservationPrevisionNbAnneeN1}
                                onBlur={e => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN1", e.target.value)}
                                onChanged={value => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN1", value)}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prévision N+2"
                                value={this.state.indicateur.reservationPrevisionNbAnneeN2}
                                onBlur={e => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN2", e.target.value)}
                                onChanged={value => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN2", value)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Prévision N+3"
                                value={this.state.indicateur.reservationPrevisionNbAnneeN3}
                                onBlur={e => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN3", e.target.value)}
                                onChanged={value => Scriba.state().setObjetPropriete(this, "indicateur", "reservationPrevisionNbAnneeN3", value)}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

        </Fragment>;
    }
}